import {
  FormDatePicker,
  FormInput,
  ModalBody,
  ModalFooter,
  ModalHeader,
  SimpleModal,
} from '@ami/react/core';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';
import { NotificationManager } from 'react-notifications';
import { QuoteProductDto } from '../../../quotes/otherQuoteEntities';
import LeadTimeOverrideCalculationService from './LeadTimeOverrideCalculationService';

export default class LeadTimeOverrideModal extends React.Component {
  state = {
    show: false,
    leadTimeItem: null,
    value: null,
    availableOn: null
  };

  static propTypes = {
    onLeadTimeOverridden: PropTypes.func.isRequired,
    quoteProduct: PropTypes.instanceOf(QuoteProductDto).isRequired,
  };

  showModal(leadTimeItem, isChange) {
    this.setState({
      show: true,
      value:  leadTimeItem.value,
      availableOn: leadTimeItem.availableOn,
      leadTimeItem
    });
  }

  hide = () => this.setState({ show: false });

  setValue = async (value, availableOn) => {
    const { leadTimeItem } = this.state;
    const { quoteProduct } = this.props;

    const leadTimeOutput = await LeadTimeOverrideCalculationService.overrideLeadTime(
      {
        productId: quoteProduct.leadTime.product.correlationId,
        state: quoteProduct.leadTime.state,
        override: { key: leadTimeItem.key, value, unit: leadTimeItem.unit, availableOn }
      });

    leadTimeItem.overrideValue = value;
    leadTimeItem.overrideAvailableOn = availableOn;

    this.props.onLeadTimeOverridden(leadTimeItem, leadTimeOutput);
    this.hide();
  }

  render() {
    const { leadTimeItem, value, availableOn } = this.state;
    if (!leadTimeItem)
      return null;

    const inHours = leadTimeItem.unit === 'Hours';
    const label = inHours ? 'Number in hours' : 'Number in days';
    const placeholder = inHours ? 'Enter the lead time in hours' : 'Enter the lead time in days';
    const errorMessage = inHours ? 'Please enter a number in hours' : 'Please enter a number in days';

    return (
      <SimpleModal show={this.state.show}>
        <ModalHeader title={`Override ${leadTimeItem.name}`} />
        <ModalBody>
          <div className="row">
            <div className="col-12">
              <FormInput
                type="number"
                min="0"
                label={label}
                placeholder={placeholder}
                value={value}
                onChange={(e) => this.setState({ value: e.target.value ? parseInt(e.target.value) : null })}
              />
            </div>
          </div>
          {availableOn &&
            <div className="row">
              <div className="col-6">
                <FormDatePicker
                  label="Available On Date"
                  selected={availableOn ? moment(availableOn) : null}
                  onChange={(e) => {
                    if (!e) {
                      NotificationManager.error("Invalid Available On Date")
                    } else {
                      this.setState({ availableOn: e.format('YYYY-MM-DD') })
                    }
                  }}
                  filterDate={(date) => !date.isBefore(moment(), 'day')}
                  placeholderText="Enter a date"
                />
              </div>
            </div>
          }
        </ModalBody>
        <ModalFooter>
          <button
            className="btn btn-primary"
            onClick={() => {
              if (this.state.value) {
                this.setValue(this.state.value, this.state.availableOn);
              } else {
                NotificationManager.error(errorMessage);
              }
            }}
          >
            Save
          </button>
          <button className="btn btn-secondary" onClick={this.hide}>
            Cancel
          </button>
        </ModalFooter>
      </SimpleModal>
    );
  }
}
